import AgentList from "./List";
import AgentImport from "./AgentImport";
import AgentShow from "./Show";
import AgentEdit from "./Edit";
import { useRecordContext } from "react-admin";

const AgentTitle = () => {
  const record = useRecordContext();

  return (
    <>
      {record
        ? `${record.firstName || ""} ${record.lastName || ""}`.trim() ||
          "Untitled Agent"
        : "Untitled Agent"}
    </>
  );
};

export { AgentList, AgentImport, AgentShow, AgentEdit, AgentTitle };
